// Addon Update Modal Handling
import { subscriptionPriceCopy } from 'subscription-builder/helpers/disclosures-formatting';
import { blendedAddonPrice } from 'default/addon-pricing';

// Initialize on Bootstrap modal shown event (PRIMARY)
$(document).on('shown.bs.modal', '#addon-update-modal', function(e) {
  // Check if modal was triggered by "Update Plan" button from plan comparison table
  const $triggerButton = $(e.relatedTarget);
  if ($triggerButton && $triggerButton.hasClass('js-update-with-addons-btn')) {
    const newUnits = parseInt($triggerButton.attr('data-addon-units')) || 0;

    // Update the modal's data-current-units to reflect the plan comparison table selection
    const $selector = $(".js-addon-selector-modal");
    if ($selector.length) {
      $selector.attr('data-current-units', newUnits);
      $selector.data('current-units', newUnits);
    }
  }

  initializeAddonSelector();
});

// Fallback: Initialize on turbo:load if modal is already visible
$(document).on("turbo:load", function() {
  if ($('#addon-update-modal').is(':visible')) {
    initializeAddonSelector();
  }
});

// Initialize on custom loomly modal event
document.addEventListener('loomly.modal.shown', function() {
  if ($('#addon-update-modal').length && $('#addon-update-modal').is(':visible')) {
    initializeAddonSelector();
  }
});

function initializeAddonSelector() {
  const $selector = $(".js-addon-selector-modal");

  if (!$selector.length) {
    return;
  }

  const addonCode = $selector.data("addon-code");
  const baseIdentities = parseInt($selector.data("base-identities"));
  const addonIncrement = parseInt($selector.data("addon-increment"));
  const addonMonthlyPrice = parseFloat($selector.data("addon-monthly-price"));
  const addonYearlyPrice = parseFloat($selector.data("addon-yearly-price"));
  const freeUnits = parseInt($selector.data("free-units")) || 0;
  const initialUnits = parseInt($selector.data("initial-units"));
  const currentUnits = parseInt($selector.data("current-units")); // May differ from initialUnits if set by Update Plan button
  const basePlanPrice = parseFloat($selector.data("base-plan-price"));
  const currentAddonPrice = parseFloat($selector.data("current-addon-price"));
  const renewalDate = $selector.data("renewal-date");
  const renewalDateFriendly = $selector.data("renewal-date-friendly") || renewalDate;
  const billingMode = $selector.data("billing-mode");
  const isYearly = billingMode === 'yearly';
  const billingPeriodLabel = isYearly ? 'year' : 'month';

  const discountEligible = $selector.data("discount-eligible") === true || $selector.data("discount-eligible") === "true";
  const fullPriceCapUnits = parseInt($selector.data("full-price-cap-units")) || 0;
  const addonDiscountedMonthlyPrice = parseFloat($selector.data("addon-discounted-monthly-price"));
  const addonDiscountedYearlyPrice = parseFloat($selector.data("addon-discounted-yearly-price"));

  function addonPriceForUnits(units) {
    return blendedAddonPrice({
      units: Math.max(0, units - freeUnits),
      fullPrice: isYearly ? addonYearlyPrice : addonMonthlyPrice,
      discountedPrice: isYearly ? addonDiscountedYearlyPrice : addonDiscountedMonthlyPrice,
      discountEligible,
      fullPriceCapUnits,
    });
  }

  // Start with current total identities (use currentUnits if set, otherwise initialUnits)
  const startingUnits = !isNaN(currentUnits) ? currentUnits : initialUnits;
  let currentTotalIdentities = baseIdentities + (startingUnits * addonIncrement);

  const $value = $(".js-addon-value-modal");
  const $increaseBtn = $(".js-addon-increase-modal");
  const $decreaseBtn = $(".js-addon-decrease-modal");
  const $unitsInput = $(".js-addon-units-input");
  const $confirmBtn = $(".js-confirm-addon-update");
  const $footerTotal = $(".js-footer-total");

  function amountDueFromPreview(preview) {
    if (preview.amount_due_today !== undefined && preview.amount_due_today !== null) {
      return parseFloat(preview.amount_due_today) || 0;
    }

    return parseFloat(preview.total) || 0;
  }

  function updateRenewalDisclosure(updatedSubscriptionPrice) {
    $(".js-renewal-disclosure-date").text(renewalDate);
    $(".js-renewal-disclosure-price").text(subscriptionPriceCopy(updatedSubscriptionPrice, billingMode));
  }

  function showAddonError(messages) {
    const text = Array.isArray(messages) ? messages.join("\n") : messages;
    $(".js-addon-error").text(text).show();
  }

  function clearAddonError() {
    $(".js-addon-error").text("").hide();
  }

  function updateUpgradeCopy(isScheduled) {
    if (isScheduled) {
      $(".js-addon-upgrade-activation-copy").text("Once you confirm, the additional Social Accounts will be added to your pending subscription.");
      $(".js-addon-upgrade-charge-prefix").text("You won't be charged today ");
      $(".js-prorated-amount").hide();
      $(".js-addon-upgrade-charge-suffix").text("for this change; the recurring price updates at renewal.");
    } else {
      $(".js-addon-upgrade-activation-copy").text("Once you confirm, the additional Social Accounts will be activated immediately.");
      $(".js-addon-upgrade-charge-prefix").text("You'll be charged ");
      $(".js-prorated-amount").show();
      $(".js-addon-upgrade-charge-suffix").text(" today for the additional add-ons.");
    }
  }

  function updateDisplay() {
    // Display total identities
    $value.text(currentTotalIdentities);

    // Calculate current addon units from total identities
    const currentUnits = Math.max(0, Math.floor((currentTotalIdentities - baseIdentities) / addonIncrement));

    // Disable decrease button if at base identities
    $decreaseBtn.prop("disabled", currentTotalIdentities <= baseIdentities);

    // Update hidden input with addon units
    $unitsInput.val(currentUnits);

    // Enable/disable confirm button
    const hasChanged = currentUnits !== initialUnits;
    $confirmBtn.prop("disabled", !hasChanged || $confirmBtn.hasClass('loading'));

    // No change shows the actual current recurring price (matches the billing summary).
    const newAddonPrice = addonPriceForUnits(currentUnits);
    const updatedSubscriptionPrice = basePlanPrice + (hasChanged ? newAddonPrice : currentAddonPrice);

    // Hide all info boxes first
    $(".js-addon-info-box-upgrade").hide();
    $(".js-addon-info-box-downgrade").hide();

    if (!hasChanged) {
      // NO CHANGE: Show upgrade box with current values (for initial state)
      clearAddonError();
      $(".js-addon-info-box-upgrade").show();
      updateUpgradeCopy(false);
      $(".js-prorated-amount").text("$0");
      $footerTotal.text("$0");
      updateRenewalDisclosure(updatedSubscriptionPrice);
      return;
    }

    $footerTotal.text("Calculating...");

    // Build addon selections object
    const addonSelections = {};
    addonSelections[addonCode] = currentUnits;

    // Fetch real preview from server
    $.ajax({
      url: '/subscription/addons/preview_invoice',
      method: 'POST',
      data: { addons: addonSelections },
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
      success: function(preview) {
        clearAddonError();

        const isScheduled = preview.scheduled === true;

        updateUpgradeCopy(isScheduled);
        $(".js-addon-info-box-upgrade").toggle(!isScheduled);
        $(".js-addon-info-box-downgrade").toggle(isScheduled);
        if (isScheduled) {
          $(".js-renewal-date-downgrade").text(renewalDateFriendly);
        }

        const totalDueToday = amountDueFromPreview(preview);
        $(".js-prorated-amount").text("$" + totalDueToday.toFixed(2));
        $footerTotal.text("$" + totalDueToday.toFixed(2));

        if (preview.total !== undefined && preview.total !== null) {
          updateRenewalDisclosure(parseFloat(preview.total));
        }
      },
      error: function(xhr) {
        const errors = (xhr.responseJSON && (xhr.responseJSON.error || xhr.responseJSON.errors)) ||
          ["We couldn't calculate the price for this change. Please try again."];
        showAddonError(errors);

        $(".js-prorated-amount").text("Unavailable");
        $footerTotal.text("Unavailable");
        $(".js-renewal-disclosure-price").text("Unavailable");
      }
    });
  }

  // Remove old event handlers to avoid duplicates
  $increaseBtn.off("click");
  $decreaseBtn.off("click");

  $increaseBtn.on("click", function(e) {
    e.preventDefault();
    currentTotalIdentities += addonIncrement;
    updateDisplay();
  });

  $decreaseBtn.on("click", function(e) {
    e.preventDefault();
    if (currentTotalIdentities > baseIdentities) {
      currentTotalIdentities -= addonIncrement;
      updateDisplay();
    }
  });

  // Submit the addon change over XHR: an immediate upgrade that needs card
  // authentication responds with a setup intent secret that must be confirmed
  // with Stripe before the change is actually applied, which a plain form
  // redirect cannot do. Non-3DS outcomes still navigate back to billing.
  $(".js-addon-update-form").off("submit.addon-update").on("submit.addon-update", function(e) {
    e.preventDefault();

    const $form = $(this);
    if ($confirmBtn.hasClass('loading')) {
      return;
    }
    $confirmBtn.addClass('loading').prop("disabled", true);
    clearAddonError();

    $.ajax({
      url: $form.attr('action'),
      method: 'PATCH',
      data: $form.serialize(),
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
      success: function(response) {
        const setupIntentSecret = response && response.setup_intent_secret;

        if (!setupIntentSecret || !window.stripeKey) {
          Turbo.visit(accountBillingPath());
          return;
        }

        confirmAddonSetup(setupIntentSecret).then(function(result) {
          if (result.error) {
            $confirmBtn.removeClass('loading').prop("disabled", false);
            showAddonError(result.error.message);
            return;
          }

          Turbo.visit(accountBillingPath());
        });
      },
      error: function(xhr) {
        $confirmBtn.removeClass('loading').prop("disabled", false);

        const errors = (xhr.responseJSON && (xhr.responseJSON.errors || xhr.responseJSON.error)) ||
          ["We couldn't update your Social Accounts. Please try again."];
        showAddonError(errors);
      }
    });
  });

  async function confirmAddonSetup(setupIntentSecret) {
    const { loadStripe } = await import('@stripe/stripe-js');
    const stripe = await loadStripe(window.stripeKey, { apiVersion: window.stripeVersion });

    return stripe.confirmCardSetup(setupIntentSecret);
  }

  function accountBillingPath() {
    return "/account/billing";
  }

  // Initialize
  updateDisplay();
}
